/**
 * traffic right icon
 * zxw
 * 2024-09-26
 */


import Icon from '@ant-design/icons';
import { ReactComponent as ICON } from '../../images/walkway-icon.svg';
 
const WalkwayIcon = (props) => {
  return <Icon component={ICON} {...props} />;
};
 
export default WalkwayIcon;